import React, { ReactNode, useCallback } from "react";
import { IconSVG } from "../../../../../shared/custom/icon/IconSVG";
import configuration from "../../../../../shared/configuration";
import useComponentVisible from "../../../../../shared/hook/useComponentVisible";

export const SubNavbar = ({
                            children,
                            isExpand = false,
                            showExpand = true,
                            setIsExpand
                          }: { children: ReactNode, isExpand?: boolean, showExpand?: boolean, setIsExpand?: (isExpand: boolean) => void, }) => {
  const handleClickOutside = useCallback(() => {
    setIsExpand?.(false);
  }, [setIsExpand]);

  const {ref, setIsComponentVisible} = useComponentVisible(isExpand, handleClickOutside);

  const toggleExpand = () => {
    const nextIsExpand = !isExpand;
    setIsComponentVisible(nextIsExpand);
    setIsExpand?.(nextIsExpand);
  };

  return (
    <div className="container-fluid sub-navbar" ref={ref}>
      {children}
      {showExpand && (
        <button
          className={`icon-expand ${isExpand ? "is-expanded" : ""}`}
          type="button"
          onClick={toggleExpand}
        >
          <IconSVG
            tintColor={configuration.theme.primary}
            icon={"chevron-down"}
            size={"16px"}
            withoutWrapper
          />
        </button>
      )}
    </div>
  );
};
